var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.424 1.735C6.33263 1.58881 6.1724 1.5 6 1.5C5.8276 1.5 5.66737 1.58881 5.576 1.735L0.576001 9.735C0.479667 9.88914 0.474566 10.0834 0.562679 10.2424C0.650792 10.4014 0.818238 10.5 1 10.5H11C11.1818 10.5 11.3492 10.4014 11.4373 10.2424C11.5254 10.0834 11.5203 9.88914 11.424 9.735L6.424 1.735ZM6 4.5C6.22091 4.5 6.4 4.67909 6.4 4.9V7.275C6.4 7.49591 6.22091 7.675 6 7.675C5.77909 7.675 5.6 7.49591 5.6 7.275V4.9C5.6 4.67909 5.77909 4.5 6 4.5ZM6.5 8.575C6.5 8.85114 6.27614 9.075 6 9.075C5.72386 9.075 5.5 8.85114 5.5 8.575C5.5 8.29886 5.72386 8.075 6 8.075C6.27614 8.075 6.5 8.29886 6.5 8.575Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.b583dcebf57acf2b70cbcc06206999ce.svg";
export { ForwardRef as ReactComponent };